module.exports = __webpack_public_path__ + "img/tablet_slide_2.04789cf9.png";